import { PlayerNumber } from '~/modules/players/player-number';
import PlayersManager from '~/modules/players/players-manager';
import { normaliseProfileName, UserProfile } from '~/modules/user-profiles/profiles';

/**
 * Puts a profile's name on a player slot - which is all "assigning a profile" means. The name is
 * what `SongStats` records, so from the next song on that slot's scores are attributed to the
 * profile, and `usePlayerProfile` reads the assignment straight back off the name.
 *
 * Only meaningful for local inputs: a slot fed by a remote microphone takes its name from the
 * phone (`nameOverride`), which deliberately wins over anything set here.
 */
export const assignProfileToPlayer = (playerNumber: PlayerNumber, profile: UserProfile | null) => {
  const player = PlayersManager.getPlayer(playerNumber);
  if (!player) return;

  player.setName(profile?.name);
};

/**
 * The profile a slot's name matches, if any. Assignment *is* the name (see above), so there is no
 * separate mapping to look up and nothing to keep in step.
 */
export const profileOnSlot = (profiles: UserProfile[], name: string | undefined) =>
  name === undefined
    ? undefined
    : profiles.find((profile) => normaliseProfileName(profile.name) === normaliseProfileName(name));

/** True when this slot's name comes from its phone, so a profile assignment would not show. */
export const playerNameIsFromRemoteMic = (playerNumber: PlayerNumber) =>
  PlayersManager.getPlayer(playerNumber)?.nameOverride !== '';
